import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-client-ltv",
  "use": "foquz-icon-client-ltv-usage",
  "viewBox": "0 0 15 14",
  "content": "<symbol viewBox=\"0 0 15 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-client-ltv\"><path d=\"M11.076 8.853a4 4 0 10-4.56-5.817M11 8A5 5 0 111 8a5 5 0 0110 0z\" stroke=\"#73808D\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol